import { VoteSelection } from "./VoteSelection";

export default VoteSelection;